(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/client.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/client.js'); 'use strict';

const trinidad = svs.core;
const {
  errorMessages,
  getJsonLDString,
  getThumbnailFromResult
} = svs.components.emp_video_player.helpers.common;
const spinnerHtmlClass = 'vjs-waiting';
const {
  setupPlayer
} = svs.components.emp_video_player.helpers.setupPlayer;
const playerConstants = svs.components.emp_video_player.helpers.constants;
const views = {
  MISSING: 'MISSING',
  THUMBNAIL: 'THUMBNAIL',
  VIDEO: 'VIDEO'
};

const vars = () => ({
  logger: new trinidad.log.Logger('components:empplayer'),
  redBeeHost: svs.components.emp_video_player.data && svs.components.emp_video_player.data.host
});

const setDefaultOptions = options => {
  options.controls = typeof options.controls === 'boolean' ? options.controls : true;
  options.customer = options.customer || 'SvenskaSpel';
  options.businessUnit = options.businessUnit || 'VOD';
  options.autoplay = typeof options.autoplay === 'boolean' ? options.autoplay : true;
  options.autoplay = options.autoplay ? 'any' : false;
  options.width = options.width || 800;
  return options;
};
const setEmpPlayerOptions = options => ({
  controlBar: options.controlBar || playerConstants.controlBar,
  controls: options.controls,
  ericssonexposure: {
    businessUnit: options.businessUnit,
    customer: options.customer,
    exposureApiURL: vars().redBeeHost
  }
});
const setPlaybackOptions = options => ({
  autoplay: options.autoplay,
  empdashif: options.empdashif || {}
});
const initPlayerOptions = options => {
  const defaultOptions = setDefaultOptions(options);
  const empPlayerOptions = setEmpPlayerOptions(options);
  const playbackOptions = setPlaybackOptions(options);
  return {
    defaultOptions,
    empPlayerOptions,
    playbackOptions
  };
};
const loadVideoComponent = callback => {
  svs.core.module.load('/cl/libs/empplayer2', undefined, error => {
    if (error) {
      vars().logger.error('failed to load empplayer2 component');
      callback(error);
    } else {
      vars().logger.debug('loaded empplayer2 component');
      callback();
    }
  }, false, true);
};

const setEvents = (player, assetId, noTracking) => {
  const {
    FIRST_PLAY,
    ERROR
  } = empPlayer.Events;
  player.on(FIRST_PLAY, () => {
    if (!noTracking) {
      const label = player.getMediaInfo().title === 'unspecified' ? assetId : player.getMediaInfo().title;
      svs.components.analytics.trackEvent({
        action: 'Start',
        category: 'Video',
        opt_label: label,
        opt_value: 1
      });
    }
  });
  player.on(ERROR, error => {
    vars().logger.info('Could not load video!', error);
    setTimeout(() => {
      player.removeClass(spinnerHtmlClass);
    }, 1000);
  });
};
const initPlayer = (videoNode, options, callback) => {
  const player = empPlayer(videoNode, options.empPlayerOptions, () => {
    player.addClass(spinnerHtmlClass);
    setEvents(player, options.assetId, options.noTracking);
    player.startPlaybackV2(options.assetId, options.playbackOptions);
    callback(player);
  });
};
const startPlayer = function (videoNode, options) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  const {
    empPlayerOptions,
    playbackOptions
  } = initPlayerOptions(options);
  const exposure = empPlayer.getExposure(empPlayerOptions.ericssonexposure);
  exposure.login('', '', response => {
    if (response.success) {
      empPlayerOptions.ericssonexposure.sessionToken = response.session.sessionToken;
      initPlayer(videoNode, {
        assetId: options.assetId,
        noTracking: options.noTracking,
        empPlayerOptions,
        playbackOptions
      }, player => {
        callback(undefined, setupPlayer({
          player
        }));
      });
    } else {
      vars().logger.warn('empplayer2 login failed', response);
      callback(response);
    }
  });
};
const startLivePlayer = function (videoNode, options) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  const {
    defaultOptions,
    empPlayerOptions,
    playbackOptions
  } = initPlayerOptions(options);
  empPlayerOptions.ericssonexposure.sessionToken = defaultOptions.sessionToken;
  initPlayer(videoNode, {
    assetId: options.assetId,
    noTracking: options.noTracking,
    empPlayerOptions,
    playbackOptions
  }, player => {
    callback(undefined, player, {
      extraButton: options.extraButton || undefined
    });
  });
};
const startVideoPlayer = function (node, options) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  const videoNode = node.querySelector('video');
  if (node.querySelector('.emp-thumbnail')) {
    node.querySelector('.emp-thumbnail').style.display = 'none';
  }
  if (options.sessionToken) {
    startLivePlayer(videoNode, options, callback);
  } else {
    startPlayer(videoNode, options, callback);
  }
};
const startVideoPlayerReact = function (videoNode, options) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  if (options.sessionToken) {
    startLivePlayer(videoNode, options, callback);
  } else {
    startPlayer(videoNode, options, callback);
  }
};

const getMeta = options => {
  const dfd = jQuery.Deferred();
  if (!options) {
    vars().logger.warn('No option parameter.');
    return;
  }
  options = setDefaultOptions(options);
  const requestUri = "".concat(vars().redBeeHost, "/v1/customer/").concat(options.customer) + "/businessunit/".concat(options.businessUnit, "/content/asset/").concat(options.assetId) + "?fieldSet=ALL&onlyPublished=true&includeUserData=false";
  if (options.assetId) {
    $.getJSON(requestUri).done(result => {
      let jsonLDTags = getJsonLDString(result);
      if (!jsonLDTags) {
        vars().logger.warn("Failed to create JSON-LD script for video: ".concat(options.assetId));
        jsonLDTags = '';
      }
      let thumbnailSrc = getThumbnailFromResult(result);
      if (thumbnailSrc) {
        thumbnailSrc += "?w=".concat(options.width);
      }
      const elementModel = {
        assetId: options.assetId,
        businessUnit: options.businessUnit,
        customer: options.customer,
        jsonLDTags,
        thumbnailSrc
      };
      dfd.resolve(elementModel);
    }).catch(error => {
      let message = "CLIENT: ".concat(errorMessages.failedWithAssetId, "=").concat(options.assetId, ". ");
      message += "Message: ".concat(error.responseText || error.statusText);
      vars().logger.warn(message);
      dfd.reject(error);
    });
  } else {
    vars().logger.warn(errorMessages.noAssetId);
    dfd.reject(errorMessages.noAssetId);
  }
  return dfd;
};

const loadView = (node, view, model, action) => {
  const {
    emp_video_player,
    missing_video,
    thumbnail,
    video_with_seo
  } = svs.components.emp_video_player.templates;
  const addClickEvent = (node, actionEvent) => {
    node.addEventListener('click', () => {
      actionEvent(node);
    });
  };
  switch (view) {
    case views.VIDEO:
      node.innerHTML = video_with_seo(model);
      break;
    case views.THUMBNAIL:
      {
        if (node) {
          node.innerHTML = thumbnail(model);
          const overlayNode = node.querySelector('.js-emp-partial-overlay');
          const clickAction = () => {
            action(node, {
              assetId: model.assetId,
              businessUnit: model.businessUnit,
              customer: model.customer
            });
          };
          addClickEvent(overlayNode, clickAction);
        }
        break;
      }
    case views.MISSING:
      node.innerHTML = missing_video({});
      break;
    default:
      node.innerHTML = emp_video_player();
      break;
  }
  return node;
};
const setupVideo = (element, options) => {
  const jQueryPromise = $.Deferred();
  if (!element) {
    return;
  }
  getMeta(options).then(result => {
    if (options.noThumbnail) {
      loadView(element, views.VIDEO, result);
      jQueryPromise.resolve();
    } else {
      loadView(element, views.THUMBNAIL, result, viewElement => {
        loadVideoComponent(() => {
          startVideoPlayer(viewElement, options);
        });
      });
      jQueryPromise.resolve();
    }
  }).catch(error => {
    loadView(element, views.MISSING);
    jQueryPromise.reject(error);
  });
  return jQueryPromise;
};
const setupVideoFromAttributes = element => {
  if (!element) {
    return;
  }
  const parent = element && element.parentNode;
  const attributes = parent.attributes;
  const options = {
    assetId: attributes['data-assetid'] && attributes['data-assetid'].value,
    businessUnit: attributes['data-businessunit'] && attributes['data-businessunit'].value,
    customer: attributes['data-customer'] && attributes['data-customer'].value
  };
  return setupVideo(parent, options);
};
svs.components.emp_video_player.helpers.client = {
  getMeta,
  loadVideoComponent,
  loadView,
  setupVideo,
  setupVideoFromAttributes,
  startVideoPlayer,
  startVideoPlayerReact
};
 })(window);